var __TEMP__ = require('./_MapCache.js');var MapCache = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_setCacheAdd.js');var setCacheAdd = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_setCacheHas.js');var setCacheHas = __REQUIRE_DEFAULT__(__TEMP__);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = SetCache;
